//
//
//
//
//
//
//
//

import { CatErrorPlaceholder } from 'counselor-mobile-ui'

export default {
  components: { CatErrorPlaceholder },

  computed: {
    errorText () {
      return this.$route.query.errorText || '加载失败，请退出后重新进入'
    },
  },

}
